import { Pressable, View } from 'react-native';
import {
  useDeleteFavorisMutation,
  useGetImplantsQuery,
  useInsertFavorisMutation,
} from '@/data/data';
import { Border, Color, Padding } from '@/GlobalStyles';
import { ActivityIndicator, Icon, Text } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import { useUserContext } from '@/components/Auth/UserContext';

type ImplantsInfoProps = {
  implantId: string;
  color: string;
};

const ImplantsInfo = (props: ImplantsInfoProps) => {
  const { implantId, color } = props;
  const { t } = useTranslation();
  const { user } = useUserContext();
  const {
    data: implantsInfos,
    loading,
    refetch,
  } = useGetImplantsQuery({
    variables: { implantsList: [implantId] },
    skip: implantId === '' || implantId === undefined,
  });

  const [insertFavoris] = useInsertFavorisMutation();
  const [deleteFavoris] = useDeleteFavorisMutation();

  if (loading && (implantsInfos?.implant.length || 0) === 0) {
    return <ActivityIndicator color={Color.MainBleu} />;
  }

  if (!implantsInfos) {
    return null;
  }

  return (
    <>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingVertical: 10,
        }}
      >
        <Text variant={'titleMedium'}>{implantsInfos?.implant[0]?.name}</Text>
        <Pressable
          onPress={async () => {
            if (implantsInfos?.implant[0].favoris.length > 0) {
              await deleteFavoris({
                fetchPolicy: 'no-cache',
                variables: {
                  implantId: implantId,
                  chirurgienId: user?.id,
                },
              });
            } else {
              await insertFavoris({
                fetchPolicy: 'no-cache',
                variables: {
                  object: {
                    implantId: implantId,
                    chirurgienId: user?.id,
                  },
                },
              });
            }
            await refetch();
          }}
          style={{
            backgroundColor:
              implantsInfos?.implant[0].favoris.length > 0 ? Color.sECJAUNE : Color.blanc,
            borderColor: Color.sECJAUNE,
            borderRadius: Border.br_31xl,
            borderWidth: 1,
            paddingHorizontal: 9,
            paddingVertical: 7,
            paddingBottom: 5,
            flexDirection: 'row',
          }}
        >
          <Text
            variant={'labelSmall'}
            style={{
              color: implantsInfos?.implant[0].favoris.length > 0 ? Color.blanc : Color.sECJAUNE,
              marginRight: 5,
            }}
          >
            {implantsInfos?.implant[0].favoris.length > 0
              ? t('Ajouté au favoris')
              : t('Ajouter au favoris')}
          </Text>
          <Icon
            color={implantsInfos?.implant[0].favoris.length > 0 ? Color.blanc : Color.sECJAUNE}
            size={15}
            source={implantsInfos?.implant[0].favoris.length > 0 ? 'star' : 'star-outline'}
          />
        </Pressable>
      </View>
      <View
        style={{
          flex: 1,
          backgroundColor: color,
          padding: Padding.p_lg,
          borderRadius: 10,
        }}
      >
        <Text>
          {implantsInfos?.implant[0]?.type} - {t(implantsInfos?.implant[0]?.materiau)}
        </Text>
        <Text>
          {t('Source')} ({implantsInfos?.implant[0]?.laboratoire?.nom})
        </Text>
        <Text>
          {t('Courbes de défocus')} ({t(implantsInfos?.implant[0]?.mb)}), {t('obtenue avec')}{' '}
          {implantsInfos?.implant[0]?.n} {t('patients')}.
        </Text>
        <Text>{implantsInfos?.implant[0]?.note}</Text>
      </View>
    </>
  );
};

export default ImplantsInfo;
